import { t } from '@lingui/macro';

export const filterDropdownList = [
  { id: 1, value: 'All', label: t`All` },
  { id: 2, value: 'Today', label: t`Today` },
  { id: 3, value: 'Tomorrow', label: t`Tomorrow` },
  { id: 3, value: 'Expired', label: t`Expired` },
];
